import { graphql } from '../generated';

export const GetLatestPosts = graphql(`
  query GetLatestPosts($first: Int = 3) {
    posts(first: $first) {
      nodes {
        id
        databaseId
        content
        title
        link
        slug
        featuredImage {
          node {
            altText
            sourceUrl
            mediaDetails {
              height
              width
            }
          }
        }
      }
    }
  }
`);
